import { createDropdownOptions } from 'src/helpers/formHelpers'
import {
  useClearances,
  useContractTypes,
  useContracts,
  useHiringManagers,
  usePositionPriorities,
  usePositionStatuses,
  useProgramManagers,
  usePositionExemptStatuses,
  usePositionWorkSettings
} from 'src/queries'

export interface UseLookupsReturn {
  contracts: ReturnType<typeof createDropdownOptions>
  statuses: ReturnType<typeof usePositionStatuses>
  contractTypes: ReturnType<typeof useContractTypes>
  priorities: ReturnType<typeof usePositionPriorities>
  programManagers: ReturnType<typeof useProgramManagers>
  hiringManagers: ReturnType<typeof useHiringManagers>
  clearances: ReturnType<typeof useClearances>
  exemptStatuses: ReturnType<typeof createDropdownOptions>
  workSettings: ReturnType<typeof createDropdownOptions>
}

const useLookups = (): UseLookupsReturn => {
  const contracts = useContracts()
  const statuses = usePositionStatuses()
  const contractTypes = useContractTypes()
  const priorities = usePositionPriorities()
  const programManagers = useProgramManagers()
  const hiringManagers = useHiringManagers()
  const clearances = useClearances()
  const exemptStatuses = usePositionExemptStatuses()
  const workSettings = usePositionWorkSettings()
  return {
    contracts: createDropdownOptions(contracts, { labelKey: 'abbreviation' }),
    statuses,
    contractTypes,
    priorities,
    programManagers,
    hiringManagers,
    clearances,
    workSettings: createDropdownOptions(workSettings),
    exemptStatuses: createDropdownOptions(exemptStatuses, { labelKey: 'name' })
  }
}

export default useLookups
